import { Error, Schedule} from '@mui/icons-material'; // или из других библиотек
 export const getMessageStatus = (msg) => {
    let icon = <Schedule />;
    let color = '#999999';
    
    if (msg.status === 'read' || msg.read_at) {
        icon = <i className="bi bi-check2-all"></i>;
        color = '#4090d9';
    } else if (msg.status === 'delivered' || msg.delivered_at) {
        icon = <i className="bi bi-check2-all"></i>;
        color = '#999999';
    } else if (msg.status === 'sent' || msg.created_at) {
        icon = <i className="bi bi-check2"></i> ;
        color = '#999999';
    } else if (msg.status === 'pending') {
        icon = <Schedule/>;
        color = '#999999';
    } else if (msg.status === 'error') {
        icon = <Error/>;
        color = '#FF4444';
    }
    
    return { icon, color };
};

